import React from "react";
import { Snackbar as MuiSnackbar, Alert } from "@mui/material";
import { SnackbarProps } from "../../../types";

interface SnackbarComponentProps {
  snackbar: SnackbarProps | null;
  setSnackbar: (snackbar: SnackbarProps) => void;
}

export const Snackbar: React.FC<SnackbarComponentProps> = ({
  snackbar,
  setSnackbar,
}) => {
  const snackbarState: SnackbarProps = snackbar || {
    open: false,
    message: "",
    severity: "success",
  };

  return (
    <MuiSnackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={snackbarState.open}
      autoHideDuration={12000}
      onClose={() => {
        if (snackbar) {
          setSnackbar({ ...snackbar, open: false });
        }
      }}
    >
      <Alert
        onClose={() => {
          if (snackbar) {
            setSnackbar({ ...snackbar, open: false });
          }
        }}
        severity={snackbarState.severity}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {snackbarState.message}
      </Alert>
    </MuiSnackbar>
  );
};
